import type { RepositoryOnboardingService, RepositoryTemplateID } from '../api'

export function templateLabel(id: RepositoryTemplateID): string {
  switch (id) {
    case 'static-spa-nginx':
      return 'Static SPA with Nginx'
    case 'go-http':
      return 'Go HTTP Service'
    case 'existing-dockerfile':
      return 'Existing Dockerfile'
  }
}

export function defaultOnboardingService(name: string): RepositoryOnboardingService {
  return {
    name,
    image_repo: `ghcr.io/237676098/${name}`,
    domain: `${name}.app.code2.top`,
    container_port: 8080,
    health_path: '',
    auto_deploy_on_push: false,
    auto_rollback: true,
    build_package: '.',
  }
}

export function warningType(message: string): 'warning' | 'error' {
  if (message.includes('listens on 80') || message.includes('does not listen')) {
    return 'error'
  }
  return 'warning'
}
